import React from "react";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";
import { AppEntities } from "../../../../config/entities";

function FixedAssetsWriteOffsList() {
  const fields: IListViewField[] = [];

  return (
    <>
      <NewDocumentListView
        fields={fields}
        entity={AppEntities.FixedAssetsWriteOffs}
      />
    </>
  );
}

export default FixedAssetsWriteOffsList;
